import React from "react";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";

const PageHeader = ({ title, action }) => {
  return (
    <div className="mb-5 sm:mb-8">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div className="flex min-w-0 items-center gap-3">
          <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-blue-600 text-white shadow-sm">
            <DashboardOutlinedIcon sx={{ fontSize: 18 }} />
          </span>
          <h1 className="min-w-0 break-words text-xl sm:text-2xl md:text-[1.65rem] font-semibold text-gray-900 leading-tight">{title}</h1>
        </div>
        {action && (
          <div className="flex flex-wrap gap-2 [&>*]:flex-1 sm:[&>*]:flex-none">{action}</div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;